import React, { useContext, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './App.css';
import Navbar from './components/Navbar.js';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import OrderHistory from './pages/orderHistory/OrderHistory.js';
import AccountsPage from './pages/Account/AccountsPage.js';
import Script from './pages/Script/Script.js';
import TradeDashboard from './pages/TradeDashboard/TradeDashboard.js';
import Profile from './pages/Profile/Profile.js';
import Login from './pages/Login/Login.js';
import Users from './pages/Users/Users.js';
import { AuthContext, AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AlertPage from './pages/PriceAlert/AlertPage.js';
import TradePage from './pages/TradePage/TradePage.js';
import XAUUSDPnLCalendar from './components/XAUUSD_pnl.js';
import axios from 'axios';
import { API_URL_SERVER } from './api/api.js';
import ManageAccounts from './components/ManageAccounts.js';
import OwnAlgo from './pages/OwnAlgo/OwnAlgo.js';

// Child component to handle context-dependent logic
function AppContent() {
  const authContext = useContext(AuthContext);
  const user = authContext ? authContext.user : null;
  const hasLoggedVisit = useRef(false); // Track if visit has been logged

  console.log('User from context:', user); // Debug user context

  useEffect(() => {
    const logVisit = async () => {
      if (user && !hasLoggedVisit.current) {
        try {
          hasLoggedVisit.current = true; // Mark visit as logged
          const api = authContext?.api || axios;
          await api.post(
            `${API_URL_SERVER}/log-visit`,
            {},
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('token')}`,
              },
            }
          );
          console.log('Visit logged successfully');
        } catch (error) {
          console.error('Error logging visit:', error);
        }
      }
    };

    logVisit();

    // Cleanup to reset hasLoggedVisit on unmount
    return () => {
      hasLoggedVisit.current = false;
    };
  }, [user, authContext]); // Dependencies remain the same

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Navbar />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <AccountsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/order-history"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <OrderHistory />
            </ProtectedRoute>
          }
        />
        <Route
          path="/algo"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Script />
            </ProtectedRoute>
          }
        />
        <Route
          path="/OwnAlgo"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <OwnAlgo />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trade-dashboard"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <TradeDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/pnl-calendar/xauusd"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <XAUUSDPnLCalendar />
            </ProtectedRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Profile />
            </ProtectedRoute>
          }
        />
        <Route
          path="/users"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <Users />
            </ProtectedRoute>
          }
        />
        <Route
          path="/manage-accounts"
          element={
            <ProtectedRoute allowedRoles={['admin']}>
              <ManageAccounts />
            </ProtectedRoute>
          }
        />
        <Route
          path="/alert/:accountId/:strategy"
          element={
            <ProtectedRoute allowedRoles={['admin','user']}>
              <AlertPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/trade/:accountId/:strategy"
          element={
            <ProtectedRoute allowedRoles={['admin', 'user']}>
              <TradePage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;